import { ButtonWithText } from '../../atoms/Buttons/ButtonWithText';
import React from 'react';
import useStyle from './ngoCard.style';

export const NgoCardView = ({ ngo, handleClickNgo, selectedNgo }) => {
  const classes = useStyle();
  return (
    <div className={classes.card}>
      <div className={classes.video}>
        <iframe
          className={classes.iframe}
          width="853"
          height="480"
          src={`https://www.youtube.com/embed/${ngo.embedId}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
      <div className={classes.content}>
        <div className={classes.contentText}>
          <div className={classes.listContainer}>
            {ngo.descriptions.map((description, index) => (
              <p key={index}>{description}</p>
            ))}
          </div>
          <div className={classes.listContainer}>
            {ngo.actions.map((action, actionsIndex) => (
              <p key={actionsIndex}>{action}</p>
            ))}
          </div>
          <div className={classes.listContainer}>
            {ngo.catchPhrases.map((catchPhrase, actionsIndex) => (
              <p key={actionsIndex}>{catchPhrase}</p>
            ))}
          </div>
          <div className={classes.listContainer}>
            {ngo.equivalences.map((equivalence, actionsIndex) => (
              <p className={classes.catchPhrase} key={actionsIndex}>
                {equivalence}
              </p>
            ))}
          </div>
        </div>
        <div className={classes.button}>
          <ButtonWithText
            content={`Je choisis ${ngo.displayName}`}
            onClick={() => handleClickNgo(ngo.name)}
            disabled={selectedNgo.ong === ngo.name}
          />
        </div>
      </div>
    </div>
  );
};
